import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { redirectUriPostSecondFactorSelector } from 'store/selectors';
import { completeSecondFactorConfiguration } from 'actions/seguridad';
import {
  AUTOGESTION_IDP,
  CONFIGURAR_SEGUNDO_FACTOR_LOGIN,
} from 'constants/RouterConstants';
import Card from 'components/Card';
import ButtonSolid from 'components/ButtonSolid';
import { datosUsuarioLogueado } from 'constants/selectors';

const Postergacion2FA = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectUriPostSecondFactor = useSelector(
    redirectUriPostSecondFactorSelector,
  );
  const usuario = useSelector(datosUsuarioLogueado);
  return (
    <Card
      title="Recordá activar el doble factor de autenticación (2FA)"
      style={{ whiteSpace: 'pre-line' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <span>
          Elegiste postergar la activación, pero este mensaje volverá a aparecer
          cada vez que ingreses, ya que más adelante se activará de forma
          obligatoria para mantener tu nivel de seguridad intermedio.
        </span>
        <span>
          <span style={{ fontWeight: 'bold' }}>Importante:</span> verficá tener
          acceso al correo registrado ({usuario?.user?.email}), porque allí se
          enviará el código cuando se active el doble factor de autenticación.
        </span>
        <span>
          Si no tenés acceso a ese correo en el momento de la activación
          automática, tendrás que realizar el cambio de forma presencial en los
          puntos de atención a la ciudadanía.
        </span>
        <span style={{ fontWeight: 'bold' }}>
          Activar el doble factor de autenticación protege tu cuenta y ayuda a
          prevenir accesos no autorizados.
        </span>
      </div>
      <div className="button-container">
        <ButtonSolid
          text="Activar el doble factor de autenticación"
          handleClick={() => {
            if (redirectUriPostSecondFactor)
              history.push(
                `${CONFIGURAR_SEGUNDO_FACTOR_LOGIN}?redirect_uri=${redirectUriPostSecondFactor}`,
              );
            else history.push(CONFIGURAR_SEGUNDO_FACTOR_LOGIN);
          }}
          style={{ marginTop: '20px' }}
        />
        <ButtonSolid
          text="Continuar"
          handleClick={() => {
            dispatch(completeSecondFactorConfiguration());
            if (redirectUriPostSecondFactor)
              window.location.href = redirectUriPostSecondFactor;
            else history.push(AUTOGESTION_IDP);
          }}
        />
      </div>
    </Card>
  );
};

export default Postergacion2FA;
